import { getHomeCatalog } from '../util/api';

export const FANS_CATEGORIES = [
  { key: '全部', label: '全部' },
];

/** 接口接入前先空列表；字段约定见 normalizeFansService */
export const FANS_PRODUCTS = [];

export function parseFansPrice(priceText) {
  const text = String(priceText || '').replace(/^\$\s*/, '').trim();
  const [unitPriceRaw, unitRaw = '1'] = text.split('/');
  const unitPrice = Number(unitPriceRaw) || 0;
  const unitMatch = String(unitRaw).match(/\d+(\.\d+)?/);
  const unit = Number(unitMatch?.[0]) || 1;
  return {
    unitPrice,
    unit,
    display: `$ ${text}`,
  };
}

function pickFansIcon(raw) {
  if (raw.icon) return raw.icon;
  const src = String(raw.src || '').trim();
  if (src && !/^https?:\/\//i.test(src) && src.length <= 8) return src;
  const title = String(raw.title || '');
  const emojiMatch = title.match(/^(\p{Extended_Pictographic}|\p{Emoji_Presentation})/u);
  if (emojiMatch) return emojiMatch[0];
  return '✈️';
}

/** 将 store_product 映射为粉丝商城卡片字段 */
export function mapProductToFansRaw(product, categoryName = '') {
  const priceNum = Number(product?.price) || 0;
  const sendWay = String(product?.sendWay || '').trim();
  const detailRaw = String(product?.detail || '');
  const detailLines = detailRaw.split(/\n/).map((s) => s.trim()).filter(Boolean);
  let placeholder = '请输入账号链接';
  const descLines = [];
  for (const line of detailLines) {
    const m = line.match(/^提示[:：]\s*(.+)$/);
    if (m) {
      placeholder = m[1].trim() || placeholder;
    } else {
      descLines.push(line);
    }
  }
  // sendWay 形如 0.05/1000 或 45/50天 时作为计价展示，否则用数字价格
  const priceText = /^\d+(\.\d+)?\/\d+/.test(sendWay)
    ? sendWay
    : String(priceNum);
  if (!/^\d+(\.\d+)?\/\d+/.test(sendWay) && sendWay) {
    placeholder = sendWay;
  }

  return {
    id: product?.id,
    category: categoryName || product?.category || '全部',
    title: product?.title || '',
    icon: pickFansIcon(product),
    description: descLines.join('\n'),
    price: priceText,
    text_placeholder: placeholder,
    src: product?.src || '',
  };
}

export function normalizeFansService(raw, index = 0) {
  const price = parseFansPrice(raw.price);
  const descList = Array.isArray(raw.description)
    ? raw.description
    : String(raw.description || raw.desc || '')
      .split(/\n/)
      .map((s) => s.trim())
      .filter((line) => line && !/^提示[:：]/.test(line));
  return {
    id: raw.id || `fans-${index}`,
    category: raw.category || '全部',
    title: raw.title || '',
    icon: pickFansIcon(raw),
    desc: descList.join(' '),
    descLines: descList,
    priceText: price.display,
    unitPrice: price.unitPrice,
    unit: price.unit,
    placeholder: raw.text_placeholder || '请输入账号链接',
  };
}

export function calcFansTotal(product, qty) {
  const quantity = Number(qty) || 0;
  const unit = Number(product?.unit) || 1;
  const unitPrice = Number(product?.unitPrice) || 0;
  if (!quantity || !unit) return 0;
  return Number(((unitPrice / unit) * quantity).toFixed(2));
}

export function iconClassFor(icon) {
  if (['🗨️', '💬', '🎵', '🎶', '📹'].includes(icon)) return 'teal';
  if (['🕊️', '👍'].includes(icon)) return 'blue';
  if (icon === '💻') return 'orange';
  return 'orange';
}

/**
 * 拉取粉丝商城分类 + 商品（mall_type=fans）
 * @returns {{ categories: {key:string,label:string}[], products: object[] }}
 */
export async function fetchFansCatalog() {
  const res = await getHomeCatalog('fans');
  const catalog = Array.isArray(res?.data) ? res.data : [];
  const categories = [{ key: '全部', label: '全部' }];
  const products = [];

  for (const cate of catalog) {
    const name = cate?.name || '';
    if (name) categories.push({ key: name, label: name });
    for (const p of cate?.products || []) {
      products.push(mapProductToFansRaw(p, name));
    }
  }

  return { categories, products };
}

/** 预留商品列表接口 */
export async function fetchFansServices() {
  const { products } = await fetchFansCatalog();
  return products;
}
